import React from 'react';
import Lightbox from 'react-image-lightbox';
var Gallery = function (_a) {
    var pictures = _a.pictures, setIsOpen = _a.setIsOpen, setIndex = _a.setIndex, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, index = _a.index;
    if (!pictures.length || !isOpen) {
        return null;
    }
    var prevIndex = (index + pictures.length - 1) % pictures.length;
    var nextIndex = (index + pictures.length + 1) % pictures.length;
    var fullSrc = pictures[index].url;
    var nextSrc = pictures[nextIndex].url;
    var prevSrc = pictures[prevIndex].url;
    var onCloseLightbox = function () {
        if (setIsOpen) {
            setIsOpen(false);
        }
    };
    return (isOpen && (React.createElement(Lightbox, { mainSrc: fullSrc, nextSrc: nextSrc, prevSrc: prevSrc, onCloseRequest: onCloseLightbox, onMovePrevRequest: function () { return setIndex(prevIndex); }, onMoveNextRequest: function () { return setIndex(nextIndex); } })));
};
export default Gallery;
//# sourceMappingURL=Gallery.js.map